import { Check, Lock, ArrowRight, Mic } from 'lucide-react';
import { Link } from 'react-router-dom';

const PLANS = [
  {
    cls: '',
    tier: 'Free',
    name: 'Daily Report',
    tagline: 'Read the full daily brief',
    price: '$0', per: '/ always free',
    equiv: 'No credit card required',
    items: [
      { on: true,  text: 'Full daily written report' },
      { on: true,  text: 'Market analysis & news-impact coverage' },
      { on: true,  text: 'Projection outcomes — Hit / Beat / Miss' },
      { on: false, text: 'Projection ranges & targets' },
      { on: false, text: 'Bull & bear case analysis' },
      { on: false, text: 'Devil\'s Advocate risk view' },
      { on: false, text: 'Stock watchlist' },
    ],
    cta: 'Start reading free',
    ctaCls: 'light',
    plan: 'free',
  },
  {
    cls: 'annual',
    badge: 'Best value',
    tier: 'Pro · Annual',
    name: 'Full Intelligence',
    tagline: 'Daily AI market intelligence for self-directed investors. 2 months free vs. monthly',
    price: '$129', per: '/ year',
    equiv: '$10.75 / month',
    items: [
      { on: true, text: 'Everything in Free' },
      { on: true, text: 'Projection ranges — all 4 period finals' },
      { on: true, text: 'Bull & bear case analysis' },
      { on: true, text: 'Devil\'s Advocate every issue' },
      { on: true, text: 'Stock watchlist & personalized feed' },
      { on: true, text: 'Intraday alerts on material changes' },
      { on: true, text: 'Daily audio briefing' },
    ],
    cta: 'Start Pro Annual',
    ctaCls: 'gold',
    plan: 'annual',
  },
  {
    cls: 'paid',
    tier: 'Pro · Monthly',
    name: 'Full Intelligence',
    tagline: 'Daily AI market intelligence for self-directed investors',
    price: '$14.95', per: '/ month',
    equiv: 'Cancel anytime',
    items: [
      { on: true, text: 'Everything in Free' },
      { on: true, text: 'Projection ranges — all 4 period finals' },
      { on: true, text: 'Bull & bear case analysis' },
      { on: true, text: 'Devil\'s Advocate every issue' },
      { on: true, text: 'Stock watchlist & personalized feed' },
      { on: true, text: 'Intraday alerts on material changes' },
      { on: true, text: 'Daily audio briefing' },
    ],
    cta: 'Start Pro Monthly',
    ctaCls: 'dark',
    plan: 'monthly',
  },
];

export default function Pricing() {
  return (
    <section className="section" id="plans">
      <div className="wrap">
        <div className="sec-tag"><ArrowRight size={13} />Pricing</div>
        <h2>Simple, honest pricing.<br /><em>Free forever. Pro when you're ready.</em></h2>
        <p className="section-lead">
          The full daily written report is always free. Pro unlocks projection ranges, bull &amp; bear cases,
          Devil's Advocate, watchlist, and audio briefing.
        </p>

        <div className="compare">
          {PLANS.map(p => (
            <div key={p.tier} className={`cc ${p.cls}`} style={{ position: 'relative' }}>
              {p.badge && <div className="cc-badge">{p.badge}</div>}
              <div className="cc-head">
                <div className="cc-tier">{p.tier}</div>
                <div className="cc-name">{p.name}</div>
                <div className="cc-tagline">{p.tagline}</div>
                <div className="cc-price">
                  <span className="cc-amt">{p.price}</span>
                  <span className="cc-per">{p.per}</span>
                </div>
                {p.equiv && <div className="cc-equiv">{p.equiv}</div>}
              </div>
              <div className="cc-body">
                {p.items.map((item, i) => (
                  <div key={i} className={`ci ${item.on ? 'on' : 'locked'}`}>
                    {item.on ? <Check size={14} /> : <Lock size={14} />}
                    {item.text}
                  </div>
                ))}
              </div>
              <div className="cc-foot">
                <Link to={`/register?plan=${p.plan}`} className={`btn-block ${p.ctaCls}`}>
                  {p.cta} <ArrowRight size={14} />
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="audio-callout">
          <div className="audio-callout-icon"><Mic size={20} /></div>
          <div className="audio-callout-text">
            <div className="audio-callout-title">Daily audio briefing included with Pro</div>
            <div className="audio-callout-sub">
              8–12 minute notebook-style podcast. Two AI hosts, sourced claims, projection outcomes — ready before market open.
            </div>
          </div>
          <div className="audio-callout-badge">Pro feature</div>
        </div>
      </div>
    </section>
  );
}
